<template>
  <nav aria-label="breadcrumb" class="breadcrumbArea" :class="classListPage ? 'breadcrumbList' : null">
    <button type="button" class="btn btnBreadcrumbBack" @click="goBack()">Geri</button>
    <b-breadcrumb :items="items" />
  </nav>
</template>

<script>
export default {
  name: "BaseBreadcrumb",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    classListPage: {
      type: Boolean,
      default: true,
    },
    backButtonRoute: {
      type: String,
      default: null,
    },
  },
  methods: {
    goBack() {
      if (this.backButtonRoute) {
        this.$router.push(this.backButtonRoute);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
